// src/js/constants/action-types.js

export const START_CLICK = "START_CLICK";
export const MODULE_CLICK = "MODULE_CLICK";
export const SUBMODULE_CLICK = "SUBMODULE_CLICK";
export const ANSWER_CLICK = "ANSWER_CLICK";
export const NEXT_MODULE_CLICK = "NEXT_MODULE_CLICK";
export const RESULTS_CLICK = "RESULTS_CLICK";
export const UPDATE_FORM_FIELD = "UPDATE_FORM_FIELD";
export const SUBMIT_FORM = "SUBMIT_FORM";